const DEPTH_LIMITS = {
  min: 0,
  max: 0.1,
  step: 0.001,
};

/* ===================================================== */

export function DepthControls({ depth, setDepth }) {
  /*
    clamp 안정성
  */

  function clamp(value, min, max) {
    return Math.min(Math.max(value, min), max);
  }

  function handleChange(rawValue) {
    const value = parseFloat(rawValue);

    const safeValue = clamp(value, DEPTH_LIMITS.min, DEPTH_LIMITS.max);

    setDepth(safeValue);
  }

  return (
    <div className='flex flex-col gap-4'>
      <Label>Depth</Label>

      <div className='flex items-center gap-3'>
        {/* slider */}

        <input
          type='range'
          min={DEPTH_LIMITS.min}
          max={DEPTH_LIMITS.max}
          step={DEPTH_LIMITS.step}
          value={depth}
          onChange={(e) => handleChange(e.target.value)}
          className='
            flex-1
            h-[3px]
            bg-[#E7E2D9]
            rounded-full
            appearance-none
            cursor-pointer

            accent-[#C6A75E]
          '
        />

        {/* value */}

        <span
          className='
            w-12
            text-[11px]
            font-medium
            text-[#1F1F1F]
            text-right
            tabular-nums
          '
        >
          {depth.toFixed(3)}
        </span>
      </div>
    </div>
  );
}

/* ===================================================== */

function Label({ children }) {
  return (
    <div
      className='
        text-[11px]
        font-semibold
        text-[#8A867F]
        uppercase
        tracking-widest
      '
    >
      {children}
    </div>
  );
}
